import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 성능 차트의 데이터(시리즈)를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getPerformanceChartData(params, config) {
    return axios.post(`${baseUrl}/performance/analysis/get-performance-analysis-chart-data.do`, params, config);
  },
  /**
   * 분석 차트 그래프 설정의 데이터를 가져온다.
   * @param  {[type]}  params [description]
   * @return {Boolean}        [description]
   * @author jda
   */
  getAnalysisSettingList(params) {
    return axios.get(`${baseUrl}/performance/analysis/get-performance-analysis-setting.do`, { params });
  },
  /**
   * 이벤트 타임라인의 데이터를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getPerformanceEventTimelineData(params) {
    return axios.post(`${baseUrl}/performance/analysis/get-event-timeline.do`, params);
  },
  /**
   * rscKey로 E2E 에이전트 리스트를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getE2EAgentListByRscKey(params) {
    return axios.get(`${baseUrl}/performance/analysis/e2e/get-agent-by-rsckey.do`, { params });
  },
  /**
   * 서비스에 포함된 관리대상의 elementType 리스트를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getElementTypeList(params) {
    return axios.get(`${baseUrl}/performance/get-element-types.do`, { params });
  },
  /**
   * 서비스에 포함된 관리대상의 objId, managetypeId 정보를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getObjsByService(params) {
    return axios.get(`${baseUrl}/performance/get-objs-by-service.do`, { params });
  },
  /**
   * 이벤트 타임라인 클릭 시 해당 시간 범위의 이벤트 리스트를 조회한다.
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getEventList(params) {
    return axios.post(`${baseUrl}/performance/analysis/get-event-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/analysis/analysis-chart.js